export const EVENT_LABEL = {
  uploaded: "subió el documento",
  viewed: "abrió la previsualización",
  downloaded: "descargó el documento",
  published: "publicó el documento",
  archived: "archivó el documento",
  unarchived: "desarchivó el documento",
  deleted: "eliminó el documento",
  renamed: "editó los metadatos",
};

export const EVENT_ICON = {
  uploaded: "Upload",
  viewed: "Eye",
  downloaded: "Download",
  published: "Check",
  archived: "Archive",
  unarchived: "ArchiveRestore",
  deleted: "Trash2",
  renamed: "PenLine",
};

export const EVENT_TONE = {
  uploaded: "var(--kr-action)",
  viewed: "var(--kr-info-500)",
  downloaded: "var(--kr-info-500)",
  published: "var(--kr-success-500)",
  archived: "var(--kr-warning-500)",
  unarchived: "var(--kr-action)",
  deleted: "var(--kr-danger-500)",
  renamed: "var(--kr-action)",
};

export const VISIBILITY_LABEL = {
  workspace: "Workspace",
  employee: "Empleado",
  private: "Privado",
};

export const STATUS_LABEL = {
  draft: "Borrador",
  published: "Publicado",
  archived: "Archivado",
};

export const STATUS_TONE = {
  draft: "warning",
  published: "success",
  archived: "neutral",
};

export const EXT_COLORS = {
  PDF: ["var(--kr-status-danger-bg)", "var(--kr-danger-700)"],
  JPG: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  JPEG: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  PNG: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  DOC: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  DOCX: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  XLS: ["var(--kr-status-success-bg)", "var(--kr-success-700)"],
  XLSX: ["var(--kr-status-success-bg)", "var(--kr-success-700)"],
};

export const TEXTAREA_STYLE = {
  width: "100%",
  border: "1px solid var(--kr-border)",
  borderRadius: 6,
  padding: 10,
  fontSize: 13,
  fontFamily: "var(--kr-font-sans)",
  outline: "none",
  resize: "vertical",
  color: "var(--kr-fg-strong)",
};
